import MixpanelLogger from '../../../../../lib/MixpanelLogger'

import {LIFE_STORY_CHAPTERS, evergreenChapterKey} from './lifeStoryContent'
import {answeredStories} from './lifeStoryTools'

/** How much of a recording counts as having listened to it all. */
export const RECORDING_FINISHED_FRACTION = 0.9

/**
 * Logs a My Story Mixpanel event (TK-2993). Every event says who acted (the
 * planholder, or a deputy reading their story), whether that user is premium,
 * and the platform, so the funnels can be cut without joining on profile
 * properties.
 */
export const trackLifeStoryEvent = ({eventName, userConfig, viewerIsOwner = true, payload = {}}) => {
  MixpanelLogger.track(eventName, {
    ...payload,
    user_type: viewerIsOwner ? 'planholder' : 'deputy',
    premium: Boolean(userConfig && userConfig.get('premium')),
    platform: 'web'
  })
}

/**
 * Where a prompt sits, counted from 1: the chapter's place in the configured
 * order and the question's place within it. The open "anything else…"
 * question comes after the chapter's configured ones.
 */
export const promptPosition = promptId => {
  const evergreenKey = evergreenChapterKey(promptId)
  const chapterIndex = LIFE_STORY_CHAPTERS.findIndex(chapter => (
    evergreenKey ? chapter.key === evergreenKey : chapter.prompts.some(prompt => prompt.id === promptId)
  ))

  if (chapterIndex < 0) return {}

  const prompts = LIFE_STORY_CHAPTERS[chapterIndex].prompts

  return {
    chapter_number: chapterIndex + 1,
    question_number: evergreenKey ? prompts.length + 1 : prompts.findIndex(prompt => prompt.id === promptId) + 1
  }
}

/**
 * The `save_my_story` payload for `story` as it's saved: `stories` is the draft
 * before the save, so a copy of this story already there (an earlier autosave,
 * or a revisit) is replaced rather than counted twice.
 */
export const savedStoryEventPayload = ({stories, story}) => {
  const otherStories = answeredStories(stories).filter(savedStory => savedStory['prompt-id'] !== story['prompt-id'])
  const chapterKeys = new Set([...otherStories.map(savedStory => savedStory['chapter-key']), story['chapter-key']])

  return {
    is_first_story: otherStories.length === 0,
    story_count: otherStories.length + 1,
    chapters_count: chapterKeys.size,
    char_count: (story.text || '').length,
    input_method: story.recording ? 'voice' : 'typed',
    audio_duration_sec: story.recording ? story.recording.duration || 0 : 0
  }
}
